import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { RootMaterialModule } from 'src/app/shared/modules/root-material.module';
import { CreateDietPlanComponent } from './create-diet-plan.component';
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { BodyMeasureComponent } from './body-measure/body-measure.component';
import { HealthIssuesComponent } from './health-issues/health-issues.component';
import { DailyRoutineComponent } from './daily-routine/daily-routine.component';
import { OtherDetailsComponent } from './other-details/other-details.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ClientEffects } from './store/diet.effects';
import { clientReducer } from './store/diet.reducer';
import { AppointmentModule } from '../appointment/appointment.module';
import { AppointmentComponent } from '../appointment/appointment.component';

const routes = [
  { path: '', component: CreateDietPlanComponent },
  { path: ':id', component: CreateDietPlanComponent },
];

@NgModule({
  declarations: [
    PersonalInfoComponent,
    BodyMeasureComponent,
    HealthIssuesComponent,
    DailyRoutineComponent,
    OtherDetailsComponent,
  ],
  imports: [
    CommonModule,
    RootMaterialModule,
    HttpClientModule,
    RouterModule.forChild(routes),
    StoreModule.forFeature('client', clientReducer),
    EffectsModule.forFeature([ClientEffects]),
  ],
  exports: [
    PersonalInfoComponent,
    BodyMeasureComponent,
    HealthIssuesComponent,
    DailyRoutineComponent,
    OtherDetailsComponent,
  ],
  // entryComponents: [AppointmentComponent],
})
export class CreateDietPlanModule {}
